import { render, staticRenderFns } from "./ls-logbook.vue?vue&type=template&id=999c9214&scoped=true"
import script from "./ls-logbook.vue?vue&type=script&lang=js"
export * from "./ls-logbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999c9214",
  null
  
)

export default component.exports